<div class="forgot-password-wrapper" *ngIf="!isLoading" fxLayout="row" fxLayoutAlign="center center">
  <div class="forgot-password-container">
    <h3>Forgot Password</h3>
    <p>Enter your email address to reset your password</p>

    <form (ngSubmit)="onSubmit()" #forgotPasswordForm="ngForm">
      <div class="filter-inputs spaceDivBottom">
        <input type="email" class="form-control" placeholder="Email Address" [(ngModel)]="email" name="email"
          required />
        <small *ngIf="isSubmitted && email == ''" class="text-danger">
          Email is required
        </small>
        <small *ngIf="isSubmitted && email && !isValidEmail(email)" class="text-danger">
          Please enter a valid email address
        </small>
      </div>

      <button class="main-button" type="submit">Resend Credentials</button>
      
      <div class="back-to-login">
        <a [routerLink]="['/login']">Back to Login</a>
      </div>
    </form>
  </div>
</div>
<!-- <app-loader [loading]="isLoading"></app-loader> -->